import { Box, Tab, Tabs, IconButton, Checkbox, FormControlLabel, Typography, Tooltip, useTheme } from "@mui/material";
import { ArticleOutlined, Check, Clear, Construction, DescriptionOutlined, DoneAll, Info, Notes, PrivacyTip, Reply, Save, Visibility } from '@mui/icons-material';
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { TabPanel } from "../../Shared/Tabs/TabPanel";
import tabProps from '../../Shared/Tabs/TabProps';
import SplitButton from "../../Shared/SplitButton";
import delay from '../../Shared/Functions/Delay';
import { AssignedUserDTO, EmployeeDetailDTO, GetBuildingDataDetailResponse, SetIsEmployeeActiveRequest } from "../../../ApiOld/ApiServerVov";
import { useNavigate } from 'react-router-dom';
import { ChangeEventArgs, HtmlEditor, Image as RTImage, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar } from '@syncfusion/ej2-react-richtexteditor';
import { useMediaPredicate } from "react-media-hook";
import { APIVovEmployeeHelper } from "../../../ApiOld/ApiOldEmployeeClient";
import EmployeeBasicDetailScene from "./Components/EmployeeBasicDetailScene";
import EmployeePersonalDetailScene from "./Components/EmployeePersonalDetailScene";
import EmployeeAdminUserVisibleScene from "./Components/EmployeeAdminUserVisibleScene";
import EmployeeBuildingsScene from "./Components/EmployeeBuildingsScene";
import { useUserLayoutContext } from "../../../Contexts/Providers/UserLayoutMenuProvider";
import { useEmployeesPermissionContext } from "../../../Contexts/Permissions/EmployeesPermissionContext";
import EmployeesMenuButtons from "./Components/EmployeesMenuButtons";
import ReusableTabs from "../InvoiceComponents/ReusableTabs";
import { TabItem } from "@syncfusion/ej2-react-navigations";
import EmployeeNotesScene from "./Components/EmployeeNotesScene";
import { EmployeeNoteDTO } from "../../../ApiOld/Api/ApiServerVov";
import EmployeeDocumentsScene from "./Documents/EmployeeDocumentsScene";

interface EmployeeDetailProps {
}

export default function EmployeeDetail(props: EmployeeDetailProps) {
    const [employee, setEmployee] = useState<EmployeeDetailDTO | undefined>(undefined);

    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [saveDone, setSaveDone] = useState<boolean>(false);
    const [errorCode, setErrorCode] = useState<number>(0);

    const params = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const biggerThan700 = useMediaPredicate("(min-width: 1100px)");
    const theme = useTheme();

    const [refreshDocuments, setRefreshDocuments] = useState(false);

    const { permissions, reloadPermissions } = useEmployeesPermissionContext();

    useEffect(() => {
        if (!permissions)
            reloadPermissions();
    }, [reloadPermissions, permissions]);

    const { setMenuButtons, setBackMenuFunction, setTitle } = useUserLayoutContext();
    useEffect(() => {
        setBackMenuFunction(() => () => { redirectToList() });
    }, []);

    useEffect(() => {
        if (params['id'] && !isNaN(parseInt(params['id']))) {
            if (parseInt(params['id']) > 0) {
                new APIVovEmployeeHelper().GetEmployeeDetail(parseInt(params['id'])).then(p => {
                    setEmployee(p);
                });
            }
            else {
                let n = new EmployeeDetailDTO({ id: 0, noteList: [] });
                setEmployee(n);
            }
        }
        else
            setEmployee(undefined);
    }, [params]);

    const addNote = () => {
        setEmployee(new EmployeeDetailDTO({ ...employee, noteList: [...employee!.noteList!, new EmployeeNoteDTO({ id: (-1) * employee!.noteList!.length, text: '', name: t('NewNote') })] }));
    };

    useEffect(() => {
        setMenuButtons(employee && permissions && <EmployeesMenuButtons
            permissions={permissions}
            employeeData={employee}
            saveDone={saveDone}
            setSaveDone={setSaveDone}
            error={errorCode}
            saveEmployee={saveEmployee}
            selectedTabIndex={selectedTabIndex}
            onAddNote={addNote}
        />);
    }, [employee, permissions, saveDone, selectedTabIndex]);


    useEffect(() => {
        if (saveDone === true)
            delay(2000).then((d) => { setSaveDone(false); });
    }, [saveDone]);

    async function saveEmployee(close: boolean) {
        console.log(employee);
        if (employee !== undefined) {
            setSaveDone(false);
            new APIVovEmployeeHelper().SaveEmployee(employee).then(p => {
                setSaveDone(true);

                if (close) {
                    redirectToList();
                }
            });
        }
    }

    const redirectToList = () => {
        navigate('/' + params['lang'] + '/' + params['domain']! + '/userlayout/employees/')
    }

    const checkAllAdminUser = useCallback((group: string | undefined, isAssigned: boolean) => {
        /* setProjectData((prev) => {
            if (!prev) {
                return prev;
            }

            const updatedAssignedUsers: AssignedUserDTO[] = prev.assignedUsers!.map((p) =>
                p.group === group ? new AssignedUserDTO({ id: p.id, isAssigned: isAssigned, name: p.name, notificationsEnabledBuildingDiaryRecords: p.notificationsEnabledBuildingDiaryRecords, notificationsEnabledRequests: p.notificationsEnabledRequests, group: p.group, groupId: p.groupId }) : p
            );

            return {
                ...prev,
                assignedUsers: updatedAssignedUsers,
            } as Partial<GetBuildingDataDetailResponse>;
        }); */
    }, [/* setProjectData, setGroupedEmployees, setGroupedUsers */]);

    const tabs = useMemo(() => employee && employee.id ? [
        {
            icon: <Info style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('buildings.basicInformation'),
            panel: <EmployeeBasicDetailScene employee={employee} setEmployee={setEmployee} />
        },
        params['id'] && {
            icon: <PrivacyTip style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('privateData'),
            panel: <EmployeePersonalDetailScene employee={employee} setEmployee={setEmployee} />
        },
        params['id'] && {
            icon: <Visibility style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('visibleForUsers'),
            panel: <EmployeeAdminUserVisibleScene employee={employee} setEmployee={setEmployee} />
        },
        params['id'] && {
            icon: <Construction style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('Projekty'),
            panel: <EmployeeBuildingsScene employee={employee} setEmployee={setEmployee} />
        },
        params['id'] && {
            icon: <ArticleOutlined style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('notes'),
            disabled: false,
            panel: <EmployeeNotesScene employee={employee} setEmployee={setEmployee} />
        }, ,
        params['id'] && {
            icon: <DescriptionOutlined style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('Documents'),
            disabled: permissions ? !permissions.employeesDocuments : true,
            panel: <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Box sx={{ background: 'white', padding: '10px', boxShadow: 3, borderRadius: '10px', width: '100%' }}>
                    <div style={{ marginTop: '16px' }}>
                        {employee.id && <EmployeeDocumentsScene refreshG={refreshDocuments} setRefreshG={setRefreshDocuments} employeeId={employee.id} />}
                    </div>
                </Box>
            </div>
        }
    ] :
        [
            {
                icon: <Info style={{ width: biggerThan700 ? '16px' : '24px' }} />,
                label: t('buildings.basicInformation'),
                panel: <EmployeeBasicDetailScene employee={employee} setEmployee={setEmployee} />
            }
        ], [biggerThan700, params, permissions, employee, t, setEmployee]);


    if (employee)
        return (
            <Box sx={{ m: 2, maxWidth: biggerThan700 ? '100vw' : '92vw', height: '100vh', overflowY: biggerThan700 ? 'inherit' : 'auto', p: 1 }}>


                <ReusableTabs
                    variant="scrollable"
                    tabs={tabs?.filter(Boolean) /* as TabItem[] */}
                    onSelectedTabChange={(index) => setSelectedTabIndex(index)}
                />
            </Box >
        );
    return <div>{t('loading...')}</div>

}